export type Review = {
  id: string
  initials: string
  avatarColor: string
  name: string
  text: string
}

export const reviews: Review[] = [
  {
    id: 'mp',
    initials: 'MP',
    avatarColor: '#1B3A5C',
    name: 'Paciente verificada',
    text: 'Hacía tiempo que buscaba un consultorio donde me explicaran todo claramente. Desde el primer contacto por WhatsApp me orientaron muy bien y en ningún momento me sentí presionada. El equipo es muy amable y profesional. Ya agendé mi segunda cita.',
  },
  {
    id: 'cr',
    initials: 'CR',
    avatarColor: '#3AAFA9',
    name: 'Paciente verificado',
    text: 'Muy buena atención desde el primer contacto por WhatsApp. Me respondieron rápido, me explicaron los costos con claridad y el tratamiento quedó perfecto. Lo recomiendo con toda confianza.',
  },
  {
    id: 'al',
    initials: 'AL',
    avatarColor: '#2A5F8F',
    name: 'Paciente verificada',
    text: 'Lo que más me gustó fue que me dieron un plan de tratamiento claro desde el principio. Sin sorpresas, sin presión. Se nota que les importa la experiencia del paciente, no solo el procedimiento.',
  },
]
